import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let IntegrationUninstallDialog = {
    selector: "vcIntegrationUninstallDialog",
    templateUrl:
        "/angular/components/integration/integration-uninstall.component.html",
    bindings: {
        product_name: "=?",
        integration: "=?",
        showDeleteSettings: "=?",
    },
    controller: class IntegrationUninstallDialogController {
        // * bindings for typescript compiler *
        public product_name: any;
        public integration: any;
        public showDeleteSettings: any;
        // ************************************

        private readonly $scope: any;
        private dialog: DialogUtils;
        public deleteSettings = false;

        constructor($scope: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
        }

        ok(): void {
            this.dialog.hide(this.deleteSettings);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("integration")
    .component(IntegrationUninstallDialog.selector, IntegrationUninstallDialog);
